var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"style-info"},[_c('InfoTitle',{attrs:{"title":"前景风格设置"}}),_c('Divider'),_c('LabelInput',{attrs:{"label":"延迟出现（秒）","time":true}}),_c('LabelInput',{attrs:{"label":"显示时长（秒）","time":true}}),_c('div',{staticClass:"button"},[_vm._v(" 撤销风格 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }